import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: 'Est-ce un format papier ou numérique ?',
    a: "Il s'agit d'un produit 100% digital (PDF Haute Résolution) qui regroupe 6 livres en 1, optimisé pour être consulté sur iPad, Tablette ou Smartphone pendant vos cours."
  }, {
    q: 'Ai-je accès aux mises à jour ?',
    a: 'Oui, vous achetez le pack une fois et vous avez un accès à vie, incluant toutes les nouvelles séquences ajoutées.'
  }, {
    q: 'Combien de temps avant de recevoir mon accès ?',
    a: "L'accès est immédiat. Dès que votre paiement est confirmé, vous recevez un email avec le lien de téléchargement pour démarrer dès aujourd'hui."
  }, {
    q: 'Faut-il être expert pour utiliser ce système ?',
    a: 'Non. Le système est conçu pour les instructeurs de tous niveaux. Chaque séquence est expliquée pas à pas avec des indications claires pour guider vos élèves.'
  }];
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-pilates-cream py-20 px-4 sm:px-6 lg:px-8" data-id="element-52">
      <div className="max-w-3xl mx-auto" data-id="element-53">
        <div className="text-center mb-12" data-id="element-54">
          <div className="bg-pilates-sage/15 text-pilates-sage-dark font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-55">
            Questions Fréquentes
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-pilates-dark leading-tight tracking-tight" data-id="element-56">
            On répond à{' '}
            <span className="italic text-pilates-rose" data-id="element-57">vos questions</span>
          </h2>
        </div>

        <div className="space-y-3" data-id="element-58">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-2xl border border-pilates-sage/20 overflow-hidden shadow-sm" data-id="element-59">
              <button onClick={() => setOpen(open === idx ? null : idx)} className="w-full flex items-center justify-between p-5 text-left hover:bg-pilates-cream/40 transition-colors" data-id="element-60">
                <span className="font-display font-semibold text-pilates-dark text-base sm:text-lg pr-4" data-id="element-61">
                  {faq.q}
                </span>
                <div className="flex-shrink-0 bg-pilates-sage-dark text-white w-8 h-8 rounded-full flex items-center justify-center" data-id="element-62">
                  {open === idx ? <Minus className="w-4 h-4" data-id="element-63" /> : <Plus className="w-4 h-4" data-id="element-64" />}
                </div>
              </button>
              {open === idx && <div className="px-5 pb-5 text-pilates-slate leading-relaxed" data-id="element-65">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}